import { useState } from 'react'
import { HiOutlinePhotograph } from 'react-icons/hi'
import Image from 'next/image'

const ImageWithBackup = (props: any) => {
  const [error, setError] = useState<boolean>(false)
  if (error)
    return (
      <div
        className={'flex flex-col justify-center items-center w-full h-full'}
      >
        <HiOutlinePhotograph size={'2rem'} />
        <strong className={'text-10 text-center mx-1'}>
          No Image Available
        </strong>
      </div>
    )

  return (
    <Image
      {...props}
      onError={() => setError(true)}
      placeholder="blur"
      blurDataURL={props?.src}
    />
  )
}

export default ImageWithBackup
